export const EDITOR_BLOCK_WIDTH = 1216;

export const EDITOR_BLOCK_GAP = 32;
export const EDITOR_CONTENT_BORDER = 1;
export const EDITOR_GROUP_WIDTH_PER_COLUMN = (column: number) => {
  return (EDITOR_BLOCK_WIDTH - EDITOR_BLOCK_GAP * (column - 1)) / column - EDITOR_CONTENT_BORDER * 4;
};
